import initialstate from './initialstate';
import * as types from '../actions/actiontypes';

export function isInternalReducer(state = {}, action) {
	switch (action.type) {
		case 'UPDATE_ISINTERNALUSER_STATE':
			return action.isInternal;
		case types.GET_USER_PREFERENCES:
			if (action.response.userType === 'Member') {
				return true;
			} else {
				return false;
			}
		default:
			return state;
	}
}
